import './FeatureTab.scss';
import { useNavigate, useLocation } from 'react-router-dom';

const tabs = [
	{
		name: 'Charge Tracker',
		link: '/evdashboard/chargetracker',
	},
	{
		name: 'Trip Report',
		link: '/evdashboard/tripreport',
	},
	{
		name: 'Utilization Insights',
		link: '/evdashboard/tripinsight',
	},
];

function FeatureTab() {
	const navigate = useNavigate();
	const location = useLocation();

	const checkTabActive = (link) => {
		return location.pathname.includes(link) ? 'active' : '';
	};

	const handleTabClick = (link) => {
		navigate(link);
	};

	return (
		<div className="FeatureTab">
			<ul>
				{tabs.map((tab, key) => (
					<li
						key={key}
						className={`tab ${checkTabActive(tab.link)}`}
						onClick={() => handleTabClick(tab.link)}
					>
						{tab.name}
					</li>
				))}
			</ul>
		</div>
	);
}

export default FeatureTab;
